import TabStackLayout from '@/views/layouts/TabStackLayout'

export default function TablesLayout() {
  return <TabStackLayout title="表格" />
}
